import { render, staticRenderFns } from "./ShipmentBase.vue?vue&type=template&id=abc8864a&scoped=true&"
import script from "./ShipmentBase.vue?vue&type=script&lang=ts&"
export * from "./ShipmentBase.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentBase.vue?vue&type=style&index=0&id=abc8864a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc8864a",
  null
  
)

export default component.exports